import { defineStore } from "pinia";
import axios from "axios";
import router from "../router/router.js";

const CLIENT_DETAIL = "clientDetails";

const initialState = getSavedState(CLIENT_DETAIL);

export const useClientUserStore = defineStore("tenant", {
  state: () => ({
    clientUserDetail: initialState,
  }),

  actions: {
    async fetchClientUserDetail() {
      const tenantSubDomain = getTenantSubDomain();
      try {
        const uri = `/auth-service/noauth/tenant/check/${tenantSubDomain}`;
        const res = await axios.get(uri);
        if (res.data.statusCode === "200") {
          router.push("/login");
          this.clientUserDetail = res.data;
          saveState(CLIENT_DETAIL, this.clientUserDetail);
        } else if (res.data.statusCode === "400") {
          router.push("/404");
        }
      } catch (error) {
        router.push("/404");
      }
    },
  },
});

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}

function getSavedState(key) {
  const state = JSON.parse(window.localStorage.getItem(key)) || null;
  return state;
}

function getTenantSubDomain() {
  const host = window.location.host;
  const parts = host.split(".");
  const domainLength = 3;
  return parts.length >= domainLength && parts[0] !== "www"
    ? parts[0]
    : process.env.VUE_APP_SUB_DOMAIN;
}
